import { Directive, EmbeddedViewRef, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs/index';
import { takeUntil } from 'rxjs/operators';
import { FeatureFlagsService } from '../core/feature-flags.service';

/**
 * This allow to use the featureFlags directive to hide elements based on Permissions /Feature keys,
 * which are passed through the featureFlags input.
 * Like this example:
 *  <ng-template [featureFlags]="['your permission key here']">
 *      <button> Vetter feature </button>
 *   </ng-template>
 *
 * NOTE:  When migrate to Angular 10+ we have this:
 *  <button *featureFlags="['your permission key here']">
 *    Vetter feature
 *  </button>
 */

@Directive({
  selector: '[featureFlags]'
})
export class FeatureFlagsDirective implements OnInit, OnDestroy {
  protected destroy$ = new Subject<void>();
  private elementViewRef: EmbeddedViewRef<any>;
  private elseTpl: TemplateRef<any>;

  @Input() featureFlags: Array<string>;
  @Input() set featureFlagsElse(templateRef: TemplateRef<any> | null) {
    this.elseTpl = templateRef;
  }

  constructor(
    private vcr: ViewContainerRef,
    private tpl: TemplateRef<any>,
    private featureFlagsState: FeatureFlagsService
  ) {}

  private showElement(tpl: TemplateRef<any>): void {
    if (!this.elementViewRef) {
      this.elementViewRef = this.vcr.createEmbeddedView(tpl);
    }
  }

  private hideElement(): void {
    this.vcr.clear();
    this.elementViewRef = null;
    if (this.elseTpl) {
      this.elementViewRef = this.vcr.createEmbeddedView(this.elseTpl);
    }
  }

  ngOnInit(): void {
    if (this.featureFlags[0] === undefined) {
      this.showElement(this.tpl);

      return;
    }
    this.featureFlagsState
      .hasFlags(this.featureFlags)
      .pipe(takeUntil(this.destroy$))
      .subscribe(hasFlags => {
        hasFlags ? this.showElement(this.tpl) : this.hideElement();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }
}
